export { TwoFactorMethodForm } from 'components/forms/forms/login/twoFactor/TwoFactorMethodForm/TwoFactorMethodForm';
export { TwoFactorSubmitForm } from 'components/forms/forms/login/twoFactor/TwoFactorSubmitForm/TwoFactorSubmitForm';
